import {
  ButtonERP,
  ButtonFilterERP,
  CalendarPrimeReact,
  Checkbox,
  DropdownPrimeReact,
  InputCurrency,
  OptionsMenuStorybook,
  SearchInput,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useGetCampoPersonalizado } from "api/CampoPersonalizado.hook"
import { GetAllCamposPersonalizadosDtoProps } from "api/DTOs/GetAllCamposPersonalizadosDto"
import { UsuarioReadingFiltersDtoProps } from "api/DTOs/UsuarioReadingFiltersDto"
import { GetPrestamosByFiltersParamsProps } from "api/Prestamos.service"
import { UsuarioReadingFiltersDtoIPagedEnumerableProps } from "api/Schemas/UsuarioReadingFiltersDtoIPagedEnumerable"
import { ESTADO_PRESTAMO, EstadoPrestamoType } from "api/Types/EstadoPrestamo"
import { TIPO_PRESTAMO, TipoPrestamoType } from "api/Types/TipoPrestamo"
import { getUsuarioByFilters } from "api/Usuario.service"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import { Tabs } from "common/components/Tabs"
import { ToggleSwitch } from "common/components/Toogle"
import { formatNumber } from "common/utils/currency"
import {
  PRESTAMO_DEFAULT_FILTERS,
  PrestamoFiltersProps,
} from "features/Contabilidad/pages/Prestamos/pages/PrestamoDetail/prestamoFilters"
import { AnimatePresence } from "framer-motion"
import { isNaN } from "lodash"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { Dispatch, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { backendDateFormat, frontendDateFormat } from "utils/formatDate"
import { EstadoPrestamo } from "./EstadoPrestamo"
import { FilteredList } from "./FilteredList/FilteredList"
import { useFilteredList } from "./FilteredList/useFilteredList"
import { TABS_COMP, getOptions } from "./constants"

export const FilterMenu = ({
  prestamosFilters,
  handlePrestamosFiltersInLocal,
  serviceQuery,
  sortingCriteria,
  skipCount,
  maxResultCount = 10,
  tabSelected,
  createNew,
  setTabSelected,
  resetPagination,
  exportToExcel,
}: {
  prestamosFilters: PrestamoFiltersProps
  handlePrestamosFiltersInLocal: (value: Partial<PrestamoFiltersProps>) => void
  serviceQuery: Dispatch<Partial<GetPrestamosByFiltersParamsProps>>
  sortingCriteria?: SortingCriteria
  skipCount?: GetPrestamosByFiltersParamsProps["SkipCount"]
  maxResultCount?: GetPrestamosByFiltersParamsProps["MaxResultCount"]
  tabSelected?: TipoPrestamoType
  createNew: () => void
  setTabSelected: (tab: TipoPrestamoType) => void
  resetPagination?: () => void
  exportToExcel: () => void
}) => {
  const { campoPersonalizado } = useGetCampoPersonalizado()

  const {
    t,
    i18n: { language },
  } = useTranslation()
  const [menuOpen, setMenuOpen] = useState(false)

  const [keyword, setKeyword] = useState<string>(prestamosFilters.KEYWORD)
  const [campoPersonalizadoSelected, setCampoPersonalizadoSelected] = useState<
    GetAllCamposPersonalizadosDtoProps | undefined
  >()
  const [campoPersonalizadoValue, setCampoPersonalizadoValue] =
    useState<string>("")
  const handleSetCamposPersonalizados = () => {
    const valueAlreadyExist =
      prestamosFilters.PERSONALIZED_FIELDS?.length &&
      prestamosFilters.PERSONALIZED_FIELDS.some(
        (campo) =>
          campo.clave === campoPersonalizadoSelected?.id &&
          campo.valor === campoPersonalizadoValue
      )
    if (
      !valueAlreadyExist &&
      campoPersonalizadoSelected?.id &&
      campoPersonalizadoValue?.trim().length > 0
    ) {
      handlePrestamosFiltersInLocal({
        PERSONALIZED_FIELDS: [
          ...prestamosFilters.PERSONALIZED_FIELDS,
          {
            label: `${campoPersonalizadoSelected?.clave}`,
            clave: `${campoPersonalizadoSelected?.id}`,
            valor: campoPersonalizadoValue,
          },
        ],
      })
      setCampoPersonalizadoSelected(undefined)
      setCampoPersonalizadoValue("")
    }
  }

  const handleAdeudosChange = (key: keyof typeof prestamosFilters.DEBTS) => {
    handlePrestamosFiltersInLocal({
      DEBTS: {
        ...PRESTAMO_DEFAULT_FILTERS.DEBTS,
        [key]: !prestamosFilters.DEBTS[key],
      },
    })
  }

  const {
    filteredList: creadorPrestamoFiltered,
    // itemsSelected: creadorPrestamoSelected,
    searchItem: searchCreadorPrestamo,
    // setItemsSelected: setCreadorPrestamo,
    onSearchItem: onSearchCreadorPrestamo,
  } = useFilteredList<
    UsuarioReadingFiltersDtoIPagedEnumerableProps,
    UsuarioReadingFiltersDtoProps
  >({
    serviceCall: getUsuarioByFilters,
    adapter: (data) =>
      data?.items?.map((item) => ({
        ...item,
        nombre: `${item.nombre} ${item.apellidos}`,
      })) ?? [],
    label: "nombre",
    itemsSelectedDefault: prestamosFilters.LOAN_CREATOR,
  })

  const openFilters = () => {
    setMenuOpen(true)
  }
  const queryFixer = (
    queryParams: Partial<GetPrestamosByFiltersParamsProps>
  ) => {
    const camposPersonalizadosParams =
      prestamosFilters.PERSONALIZED_FIELDS?.length &&
      prestamosFilters.PERSONALIZED_FIELDS.reduce(
        (acc, { clave, valor }, index) => {
          acc[`CamposPersonalizados[${index}].clave`] = clave
          acc[`CamposPersonalizados[${index}].valor`] = valor
          return acc
        },
        {}
      )

    const prestamoParams = {
      ...camposPersonalizadosParams,
      CamposPersonalizados: queryParams.CamposPersonalizados,
      CreationUserIds: queryParams.CreationUserIds,
      Estado: queryParams.Estado,
      FechaLowerLimit: queryParams.FechaLowerLimit,
      FechaUpperLimit: queryParams.FechaUpperLimit,
      ImporteAmortizacionLowerLimit: queryParams.ImporteAmortizacionLowerLimit,
      ImporteAmortizacionUpperLimit: queryParams.ImporteAmortizacionUpperLimit,
      ImporteLowerLimit: queryParams.ImporteLowerLimit,
      ImporteUpperLimit: queryParams.ImporteUpperLimit,
      Keyword: queryParams.Keyword,
      NoTieneDeuda: queryParams.NoTieneDeuda,
      PendienteDePago: queryParams.PendienteDePago,
      TieneDeuda: queryParams.TieneDeuda,
      TipoPrestamo: queryParams.TipoPrestamo,
      IsEnabled: queryParams.IsEnabled,
      MaxResultCount: queryParams.MaxResultCount,
      SkipCount: queryParams.SkipCount,
      SortingCriteria:
        queryParams.SortingCriteria?.property &&
        queryParams.SortingCriteria?.sort
          ? `${queryParams.SortingCriteria.property} ${queryParams.SortingCriteria.sort}`
          : "fecha DESC,identificador DESC",
    }
    const fixedQueryParams = Object.fromEntries(
      Object.entries(prestamoParams).filter(
        ([_key, value]) => value || value === 0 // eslint-disable-line @typescript-eslint/no-unused-vars
      )
    )
    return fixedQueryParams
  }
  const query = {
    CreationUserIds: prestamosFilters.LOAN_CREATOR?.flatMap(
      (usuario) => usuario.id
    ) as unknown as string[],
    Estado: Object.entries(prestamosFilters.ESTADOS)
      .filter(([_key, value]) => value) // eslint-disable-line @typescript-eslint/no-unused-vars
      .flatMap(([key]) => key) as unknown as EstadoPrestamoType[],
    ImporteAmortizacionLowerLimit: prestamosFilters.AMORTIZED_AMOUNT?.min,
    ImporteAmortizacionUpperLimit: prestamosFilters.AMORTIZED_AMOUNT?.max,
    ImporteLowerLimit: prestamosFilters.AMOUNT?.min,
    ImporteUpperLimit: prestamosFilters.AMOUNT?.max,
    FechaLowerLimit:
      prestamosFilters.DATES?.min &&
      backendDateFormat(new Date(prestamosFilters.DATES.min)),
    FechaUpperLimit:
      prestamosFilters.DATES?.max &&
      backendDateFormat(new Date(prestamosFilters.DATES.max)),
    PendienteDePago: prestamosFilters.CURRENT_SHARE,
    TieneDeuda: prestamosFilters.DEBTS.WITH_DEBT,
    TipoPrestamo: prestamosFilters.TAB_SELECTED,
    NoTieneDeuda: prestamosFilters.DEBTS.WITHOUT_DEBT,
    SortingCriteria: sortingCriteria,
    SkipCount: skipCount,
    MaxResultCount: maxResultCount,
    Keyword: prestamosFilters.KEYWORD ?? keyword,
  }
  const handleQuery = () => {
    serviceQuery(queryFixer(query))
  }
  const handleApplyFilters = () => {
    setMenuOpen(false)
  }
  const hideFilter = () => {
    setMenuOpen(!menuOpen)
  }

  const toggleEstado = (key: EstadoPrestamoType) => {
    handlePrestamosFiltersInLocal({
      ESTADOS: {
        ...prestamosFilters.ESTADOS,
        [key]: !prestamosFilters.ESTADOS[key],
      },
    })
  }

  const mapcamposPersonalizadosTags = prestamosFilters.PERSONALIZED_FIELDS?.map(
    (campo) => ({
      label: `${campo?.label}:`,
      value: campo?.valor,
      action: () =>
        handlePrestamosFiltersInLocal({
          PERSONALIZED_FIELDS: prestamosFilters.PERSONALIZED_FIELDS?.filter(
            (selectedCampo) => selectedCampo !== campo
          ),
        }),
    })
  )
  const mapCreadorPrestamoTags = prestamosFilters.LOAN_CREATOR?.map(
    (creador) => ({
      label: creador?.nombre
        ? `${t("filtros.prestamo.tags.creator", {
            activity: creador.nombre,
          })}`
        : "",
      value: creador?.nombre ?? undefined,
      action: () =>
        handlePrestamosFiltersInLocal({
          LOAN_CREATOR: prestamosFilters.LOAN_CREATOR?.filter(
            (selectedCreador) => selectedCreador !== creador
          ),
        }),
    })
  )
  const appliedFiltersTags = [
    {
      label: `${t("filtros.prestamo.tags.status")}`,
      value: prestamosFilters.ESTADOS[ESTADO_PRESTAMO.EN_PROGRESO]
        ? t("prestamos.state.inProgressLabel")
        : undefined,
      action: () => toggleEstado(ESTADO_PRESTAMO.EN_PROGRESO),
    },
    {
      label: `${t("filtros.prestamo.tags.status")}`,
      value: prestamosFilters.ESTADOS[ESTADO_PRESTAMO.COMPLETADO]
        ? t("prestamos.state.completLabel")
        : undefined,
      action: () => toggleEstado(ESTADO_PRESTAMO.COMPLETADO),
    },
    {
      label: `${t("filtros.prestamo.tags.status")}:`,
      value: prestamosFilters.ESTADOS[ESTADO_PRESTAMO.PENDIENTE]
        ? t("prestamos.state.penddingLabel")
        : undefined,
      action: () => toggleEstado(ESTADO_PRESTAMO.PENDIENTE),
    },
    {
      label: `${t("filtros.prestamo.tags.debt")}`,
      value: prestamosFilters.DEBTS.WITH_DEBT
        ? t("filtros.prestamo.inDebtLabel")
        : undefined,
      action: () => handleAdeudosChange("WITH_DEBT"),
    },
    {
      label: `${t("filtros.prestamo.tags.debt")}:`,
      value: prestamosFilters.DEBTS.WITHOUT_DEBT
        ? t("filtros.prestamo.withOutDebtLabel")
        : undefined,
      action: () => handleAdeudosChange("WITHOUT_DEBT"),
    },
    {
      label: `${t("filtros.prestamo.tags.quote")}`,
      value:
        prestamosFilters.CURRENT_SHARE && t("filtros.prestamo.payPendingLabel"),
      action: () =>
        handlePrestamosFiltersInLocal({
          CURRENT_SHARE: PRESTAMO_DEFAULT_FILTERS.CURRENT_SHARE,
        }),
    },
    {
      label: `${t("filtros.prestamo.tags.dateFrom")}`,
      value: prestamosFilters.DATES?.min
        ? frontendDateFormat(new Date(prestamosFilters.DATES.min))
        : undefined,
      action: () =>
        handlePrestamosFiltersInLocal({
          DATES: { ...prestamosFilters.DATES, min: undefined },
        }),
    },
    {
      label: `${t("filtros.prestamo.tags.dateTo")}`,
      value: prestamosFilters.DATES?.max
        ? frontendDateFormat(new Date(prestamosFilters.DATES.max))
        : undefined,
      action: () =>
        handlePrestamosFiltersInLocal({
          DATES: { ...prestamosFilters.DATES, max: undefined },
        }),
    },
    {
      label: t("filtros.prestamo.tags.amountFrom"),
      value: prestamosFilters.AMOUNT?.min
        ? frontendCurrency(prestamosFilters.AMOUNT?.min)
        : undefined,
      action: () =>
        handlePrestamosFiltersInLocal({
          AMOUNT: { ...prestamosFilters.AMOUNT, min: undefined },
        }),
    },
    {
      label: t("filtros.prestamo.tags.amountTo"),
      value: prestamosFilters.AMOUNT?.max
        ? frontendCurrency(prestamosFilters.AMOUNT?.max)
        : undefined,
      action: () =>
        handlePrestamosFiltersInLocal({
          AMOUNT: { ...prestamosFilters.AMOUNT, max: undefined },
        }),
    },
    {
      label: t("filtros.prestamo.tags.amortizedAmountFrom"),
      value: prestamosFilters.AMORTIZED_AMOUNT?.min
        ? frontendCurrency(prestamosFilters.AMORTIZED_AMOUNT?.min)
        : undefined,
      action: () =>
        handlePrestamosFiltersInLocal({
          AMORTIZED_AMOUNT: {
            ...prestamosFilters.AMORTIZED_AMOUNT,
            min: undefined,
          },
        }),
    },
    {
      label: t("filtros.prestamo.tags.amortizedAmountTo"),
      value: prestamosFilters.AMORTIZED_AMOUNT?.max
        ? frontendCurrency(prestamosFilters.AMORTIZED_AMOUNT?.max)
        : undefined,
      action: () =>
        handlePrestamosFiltersInLocal({
          AMORTIZED_AMOUNT: {
            ...prestamosFilters.AMORTIZED_AMOUNT,
            max: undefined,
          },
        }),
    },
    ...(mapCreadorPrestamoTags ?? []),
    ...(mapcamposPersonalizadosTags ?? []),
  ]
  const appliedFilters = appliedFiltersTags.filter((filter) => filter.value)

  useEffect(() => {
    resetPagination?.()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, appliedFilters?.length, tabSelected])

  useEffect(() => {
    handleQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tabSelected,
    keyword,
    sortingCriteria?.sort,
    sortingCriteria?.property,
    skipCount,
    maxResultCount,
    appliedFilters?.length,
    prestamosFilters.DATES?.min,
    prestamosFilters.DATES?.max,
    prestamosFilters.AMOUNT?.min,
    prestamosFilters.AMOUNT?.max,
    prestamosFilters.LOAN_CREATOR,
    prestamosFilters.AMORTIZED_AMOUNT?.min,
    prestamosFilters.AMORTIZED_AMOUNT?.max,
    prestamosFilters.DEBTS.WITH_DEBT,
    prestamosFilters.DEBTS.WITHOUT_DEBT,
    prestamosFilters.PERSONALIZED_FIELDS?.length,
  ])

  const handleResetFilters = () => {
    handlePrestamosFiltersInLocal({
      ...PRESTAMO_DEFAULT_FILTERS,
      KEYWORD: keyword,
      TAB_SELECTED: tabSelected,
    })
  }

  const handleTabSelected = (type: TipoPrestamoType) => {
    setTabSelected(type)
    handlePrestamosFiltersInLocal({
      TAB_SELECTED: type,
    })
  }

  const handleKeyword = (ev: string) => {
    resetPagination?.()
    setKeyword(ev)
    handlePrestamosFiltersInLocal({
      KEYWORD: ev,
    })
  }

  return (
    <div className='!tw-px-6 tw-flex tw-flex-col xl:tw-flex-row tw-justify-between tw-items-center tw-pb-4 tw-pt-6 tw-shadow-3xl tw-rounded-t-xl mb-1 tw-bg-white'>
      <div className='tw-grid tw-grid-cols-1 tw-items-center tw-text-nowrap tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-flex-1'>
        <span className='tw-w-full tw-flex-1 tw-truncate tw-overflow-hidden tw-text-2xl tw-font-medium tw-text-left'>
          {`${t("prestamos.title")}`}
        </span>
      </div>
      <div className='tw-flex tw-w-fit tw-justify-center lg:tw-justify-end'>
        <div className='!tw-w-fit tw-flex tw-items-center !tw-flex-row tw-justify-end tw-flex-wrap'>
          <div className='tw-grid tw-gap-3 lg:tw-flex lg:tw-flex-row md:tw-grid-cols-1 tw-items-center tw-w-fit'>
            <SearchInput
              placeholder={`${t("taxSummary.detail.search")}`}
              onChange={(ev: string) => {
                handleKeyword(ev)
              }}
              inputValue={keyword}
              className='tw-mb-1 sm:tw-mb-0 tw-h-10 tw-w-full lg:tw-w-72'
            />
            <ButtonFilterERP
              isActive={appliedFilters.length > 0}
              numberActive={appliedFilters.length}
              onClick={openFilters}
              deleteFilter={handleResetFilters}
              filterButtonLabel={`${t("filtros.title")}`}
            />
            <ButtonERP
              customize={{
                type: "secondary",
                size: "md",
              }}
              onClick={createNew}
              label={`${t("prestamos.addLoan")}`}
            />
            <Tabs
              tabs={[
                {
                  key: "tab1",
                  children: t("prestamos.grantedLabel"),
                  onClickAction: () => {
                    tabSelected === TIPO_PRESTAMO.RECIBIDO &&
                      handleTabSelected(TIPO_PRESTAMO.CONCEDIDO)
                  },
                },
                {
                  key: "tab2",
                  children: t("prestamos.receivedLabel"),
                  onClickAction: () => {
                    tabSelected === TIPO_PRESTAMO.CONCEDIDO &&
                      handleTabSelected(TIPO_PRESTAMO.RECIBIDO)
                  },
                },
              ]}
              defaultTabIndex={
                prestamosFilters.TAB_SELECTED === TIPO_PRESTAMO.CONCEDIDO
                  ? TABS_COMP.FIRST_TAB
                  : TABS_COMP.SECOND_TAB
              }
            />
            <OptionsMenuStorybook
              items={getOptions(exportToExcel, t)}
              position='right'
            />
          </div>
        </div>
      </div>
      <AnimatePresence>
        <Dialog
          breakpoints={{ "575px": "100vw" }}
          className='!tw-m-0 !tw-h-full tw-select-none !tw-w-100'
          header={t("filtros.title")}
          visible={menuOpen}
          footer={
            <div className='tw-w-full tw-border-t-2 tw-pt-6'>
              <ButtonERP
                customize={{
                  type: "primary",
                  size: "md",
                }}
                className='!tw-w-full'
                onClick={handleApplyFilters}
                label={`${t("filtros.labelApply")}`}
              />
            </div>
          }
          onHide={() => {
            hideFilter()
          }}
          draggable={false}
          resizable={false}
          position='right'
          closable
          closeOnEscape
        >
          {!!appliedFilters?.length && (
            <div className='tw-mb-8'>
              <div className='tw-flex tw-mb-4 tw-justify-between'>
                <span className='tw-font-medium'>
                  {t("tickets.filter.appliedFilters")}
                </span>
                <span
                  onClick={handleResetFilters}
                  className='tw-text-text-hyperlinks tw-cursor-pointer'
                >
                  {t("tickets.filter.deleteAll")}
                </span>
              </div>
              <div className='tw-flex tw-flex-wrap tw-mb-8 tw-gap-2 tw-font-normal tw-text-xs'>
                {appliedFilters.map((filter) => (
                  <div
                    key={`${filter.label}-${filter.value}`}
                    onClick={filter.action}
                    className='tw-items-center tw-justify-between tw-cursor-pointer tw-bg-info-10 tw-text-info tw-rounded-md tw-border tw-border-info tw-py-1 tw-px-2'
                  >
                    <span>
                      {filter.label} {filter.value}
                    </span>
                    <FontAwesomeIcon
                      icon={["fal", "xmark"]}
                      className='tw-ml-2 tw-text-info'
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className='tw-mb-8'>
            <div className='tw-mb-4'>
              <span className='tw-font-medium'>
                {t("filtros.prestamo.statusTitle")}
              </span>
            </div>
            <div className='tw-flex tw-items-center tw-py-1'>
              <Checkbox
                id='conciliacion-sin-conciliar'
                className='tw-mr-4'
                isChecked={
                  prestamosFilters.ESTADOS[ESTADO_PRESTAMO.EN_PROGRESO]
                }
                onClick={() => toggleEstado(ESTADO_PRESTAMO.EN_PROGRESO)}
              />
              <span
                className='tw-items-center tw-mb-0 tw-py-1 tw-cursor-pointer'
                onClick={() => toggleEstado(ESTADO_PRESTAMO.EN_PROGRESO)}
              >
                <EstadoPrestamo
                  variant={ESTADO_PRESTAMO.EN_PROGRESO}
                  t={t}
                />
              </span>
            </div>
            <div className='tw-flex tw-items-center tw-py-1'>
              <Checkbox
                id='conciliacion-parcial'
                className='tw-mr-4'
                isChecked={prestamosFilters.ESTADOS[ESTADO_PRESTAMO.COMPLETADO]}
                onClick={() => toggleEstado(ESTADO_PRESTAMO.COMPLETADO)}
              />
              <span
                className='tw-items-center tw-mb-0 tw-py-1 tw-cursor-pointer'
                onClick={() => toggleEstado(ESTADO_PRESTAMO.COMPLETADO)}
              >
                <EstadoPrestamo
                  variant={ESTADO_PRESTAMO.COMPLETADO}
                  t={t}
                />
              </span>
            </div>
          </div>
          <div className='tw-mb-8'>
            <div className='tw-mb-4'>
              <span className='tw-font-medium'>
                {t("filtros.prestamo.adeudoLabel")}
              </span>
            </div>
            <div className='tw-w-full tw-flex tw-flex-col mobile:tw-flex-row tw-justify-between tw-items-center tw-mb-6'>
              <div className='tw-w-full tw-flex tw-flex-row tw-justify-between mobile:tw-justify-start tw-items-center tw-gap-4 tw-mb-6'>
                <span>{t("filtros.prestamo.inDebtLabel")}</span>
                <ToggleSwitch
                  id='adeudo-con-deuda'
                  defaultChecked={prestamosFilters.DEBTS.WITH_DEBT}
                  checkedState={prestamosFilters.DEBTS.WITH_DEBT}
                  onChangeHandler={() => handleAdeudosChange("WITH_DEBT")}
                />
              </div>
              <div className='tw-w-full tw-flex tw-flex-row tw-justify-between mobile:tw-justify-end tw-items-center tw-gap-4 tw-mb-6'>
                <span>{t("filtros.prestamo.withOutDebtLabel")}</span>
                <ToggleSwitch
                  id='adeudo-sin-deuda'
                  defaultChecked={prestamosFilters.DEBTS.WITHOUT_DEBT}
                  checkedState={prestamosFilters.DEBTS.WITHOUT_DEBT}
                  onChangeHandler={() => handleAdeudosChange("WITHOUT_DEBT")}
                />
              </div>
            </div>
          </div>
          <div className='tw-mb-8'>
            <div className='tw-mb-4'>
              <span className='tw-font-medium'>
                {t("filtros.prestamo.actualQuoteLabel")}
              </span>
            </div>
            <div className='tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-mb-6'>
              <span>{t("filtros.prestamo.payPendingLabel")}</span>
              <ToggleSwitch
                id='pendiente-de-pago'
                defaultChecked={prestamosFilters.CURRENT_SHARE}
                checkedState={prestamosFilters.CURRENT_SHARE}
                onChangeHandler={() =>
                  handlePrestamosFiltersInLocal({
                    CURRENT_SHARE: !prestamosFilters.CURRENT_SHARE,
                  })
                }
              />
            </div>
          </div>
          <div className='tw-mb-8'>
            <div className='tw-mb-4'>
              <span className='tw-font-medium'>
                {t("filtros.prestamo.date")}
              </span>
            </div>
            <div className='tw-flex tw-flex-col mobile:tw-flex-row tw-mb-6'>
              <div className='tw-flex tw-flex-col tw-flex-grow tw-mb-4 mobile:tw-mb-0'>
                <label>{t("nsAssets.filters.date.since")}</label>
                <CalendarPrimeReact
                  id='fechaDesde'
                  name='fechaDesde'
                  clearButtonClassName='!tw-hidden'
                  value={
                    prestamosFilters.DATES?.min
                      ? new Date(prestamosFilters.DATES.min)
                      : undefined
                  }
                  locale={language}
                  onChange={(e) => {
                    const eventDate = e.target.value as unknown as string
                    handlePrestamosFiltersInLocal({
                      DATES: {
                        max:
                          prestamosFilters.DATES?.max &&
                          new Date(eventDate) >
                            new Date(prestamosFilters.DATES?.max)
                            ? undefined
                            : prestamosFilters.DATES?.max,
                        min: eventDate,
                      },
                    })
                  }}
                  placeholder='dd/mm/aaaa'
                  dateFormat='dd/mm/yy'
                  className='w-full'
                  baseZIndex={2302}
                  showIcon
                  maxDate={
                    prestamosFilters.DATES?.max
                      ? new Date(prestamosFilters.DATES.max)
                      : undefined
                  }
                />
              </div>
              <div className='tw-hidden mobile:tw-block tw-py-3 tw-px-3 tw-items-baseline tw-mt-auto tw-mb-0'>
                -
              </div>
              <div className='tw-flex tw-flex-col tw-flex-grow'>
                <label>{t("nsAssets.filters.date.until")}</label>
                <CalendarPrimeReact
                  id='fechaHasta'
                  name='fechaHasta'
                  clearButtonClassName='!tw-hidden'
                  value={
                    prestamosFilters.DATES?.max
                      ? new Date(prestamosFilters.DATES.max)
                      : undefined
                  }
                  locale={language}
                  onChange={(e) => {
                    const eventDate = e.target.value as unknown as string
                    handlePrestamosFiltersInLocal({
                      DATES: {
                        min:
                          prestamosFilters.DATES?.min &&
                          new Date(eventDate) <
                            new Date(prestamosFilters.DATES?.min)
                            ? undefined
                            : prestamosFilters.DATES?.min,
                        max: eventDate,
                      },
                    })
                  }}
                  placeholder='dd/mm/aaaa'
                  dateFormat='dd/mm/yy'
                  className='w-full'
                  baseZIndex={2302}
                  showIcon
                  minDate={
                    prestamosFilters.DATES?.min
                      ? new Date(prestamosFilters.DATES.min)
                      : undefined
                  }
                />
              </div>
            </div>
          </div>
          <div className='tw-mb-8'>
            <div className='tw-mb-4'>
              <span className='tw-font-medium'>
                {t("filtros.prestamo.amount")}
              </span>
            </div>
            <div className='tw-flex tw-flex-row tw-mb-8'>
              <div className='tw-flex tw-flex-col'>
                <label>
                  {t("bancos.conciliacion.filterMenu.amountLabelSince")}
                </label>
                <InputCurrency
                  placeholder='0,00'
                  value={prestamosFilters.AMOUNT.min}
                  onChange={(value) =>
                    handlePrestamosFiltersInLocal({
                      AMOUNT: {
                        ...prestamosFilters.AMOUNT,
                        min: isNaN(value) ? undefined : value,
                      },
                    })
                  }
                  min={0}
                  max={prestamosFilters.AMOUNT.max ?? Number.MAX_SAFE_INTEGER}
                />
              </div>
              <div className='tw-py-3 tw-px-6 tw-items-baseline tw-mt-auto tw-mb-0'>
                -
              </div>
              <div className='tw-flex tw-flex-col'>
                <label>
                  {t("bancos.conciliacion.filterMenu.amountLabelUntil")}
                </label>

                <InputCurrency
                  placeholder={
                    prestamosFilters.AMOUNT.min
                      ? `${formatNumber(prestamosFilters.AMOUNT.min)}`
                      : "0,00"
                  }
                  value={prestamosFilters.AMOUNT.max}
                  onChange={(value) =>
                    handlePrestamosFiltersInLocal({
                      AMOUNT: {
                        ...prestamosFilters.AMOUNT,
                        max: isNaN(value) ? undefined : value,
                      },
                    })
                  }
                  min={prestamosFilters.AMOUNT.min ?? 0}
                  max={Number.MAX_SAFE_INTEGER}
                />
              </div>
            </div>
          </div>
          <div className='tw-mb-8'>
            <div className='tw-mb-4'>
              <span className='tw-font-medium'>
                {t("filtros.prestamo.amortizedAmount")}
              </span>
            </div>
            <div className='tw-flex tw-flex-row tw-mb-8'>
              <div className='tw-flex tw-flex-col'>
                <label>
                  {t("bancos.conciliacion.filterMenu.amountLabelSince")}
                </label>
                <InputCurrency
                  placeholder='0,00'
                  value={prestamosFilters.AMORTIZED_AMOUNT.min}
                  onChange={(value) =>
                    handlePrestamosFiltersInLocal({
                      AMORTIZED_AMOUNT: {
                        ...prestamosFilters.AMORTIZED_AMOUNT,
                        min: isNaN(value) ? undefined : value,
                      },
                    })
                  }
                  min={0}
                  max={
                    prestamosFilters.AMORTIZED_AMOUNT.max ??
                    Number.MAX_SAFE_INTEGER
                  }
                />
              </div>
              <div className='tw-py-3 tw-px-6 tw-items-baseline tw-mt-auto tw-mb-0'>
                -
              </div>
              <div className='tw-flex tw-flex-col'>
                <label>
                  {t("bancos.conciliacion.filterMenu.amountLabelUntil")}
                </label>
                <InputCurrency
                  placeholder={
                    prestamosFilters.AMORTIZED_AMOUNT.min
                      ? `${formatNumber(prestamosFilters.AMORTIZED_AMOUNT.min)}`
                      : "0,00"
                  }
                  value={prestamosFilters.AMORTIZED_AMOUNT.max}
                  onChange={(value) =>
                    handlePrestamosFiltersInLocal({
                      AMORTIZED_AMOUNT: {
                        ...prestamosFilters.AMORTIZED_AMOUNT,
                        max: isNaN(value) ? undefined : value,
                      },
                    })
                  }
                  min={prestamosFilters.AMORTIZED_AMOUNT.min ?? 0}
                  max={Number.MAX_SAFE_INTEGER}
                />
              </div>
            </div>
          </div>
          <div className='tw-mb-8'>
            <div className='tw-mb-4'>
              <span className='tw-font-medium'>
                {t("filtros.prestamo.personalFields")}
              </span>
            </div>
            <div className='tw-flex tw-flex-col'>
              <div className='tw-flex tw-flex-col tw-flex-grow tw-mb-4'>
                <label>{t("filtros.prestamo.fieldLabel")}</label>
                <DropdownPrimeReact
                  id='campos-personalizados-select'
                  className='!tw-text-neutral-25 tw-w-full tw-rounded tw-h-10 [&>:nth-child(3)]:!tw-font-roboto [&>.p-placeholder]:!tw-text-neutral-50 !tw-border-neutral-25'
                  panelClassName='!tw-max-w-xl !tw-z-[2303]'
                  scrollHeight='350px'
                  placeholder={`${t("filtros.prestamo.fieldLabelPlaceholder")}`}
                  emptyFilterMessage={`${t("filtros.prestamo.noResultsFound")}`}
                  emptyMessage={`${t("filtros.prestamo.noResultsFound")}`}
                  value={campoPersonalizadoSelected}
                  onChange={(e) => {
                    setCampoPersonalizadoSelected(e.value)
                  }}
                  options={campoPersonalizado?.items ?? []}
                  optionLabel='clave'
                  filter
                />
              </div>
              <div className='tw-flex tw-flex-col tw-flex-grow tw-mb-4'>
                <label>{t("filtros.prestamo.valueLabel")}</label>
                <InputText
                  className='tw-w-full sm:tw-min-w-72 tw-pl-2 tw-h-10'
                  placeholder={`${t("filtros.prestamo.valueLabelPlaceholder")}`}
                  defaultValue={campoPersonalizadoValue}
                  value={campoPersonalizadoValue}
                  onChange={(ev) => {
                    setCampoPersonalizadoValue(ev.target.value)
                  }}
                  onBlur={handleSetCamposPersonalizados}
                />
              </div>
              <div
                className='tw-flex tw-justify-center tw-text-text-hyperlinks tw-cursor-pointer aria-[disabled=true]:tw-text-neutral-50'
                onClick={handleSetCamposPersonalizados}
                aria-disabled={
                  !campoPersonalizadoSelected?.id ||
                  campoPersonalizadoValue.trim().length === 0
                }
              >
                {t("filtros.prestamo.addAnotherField")}
              </div>
            </div>
          </div>
          <div className='tw-mb-8'>
            <div className='tw-mb-4'>
              <span className='tw-font-medium'>
                {t("filtros.prestamo.loanCreator")}
              </span>
            </div>
            <div className='tw-flex tw-flex-col tw-mb-8'>
              <FilteredList
                filteredList={creadorPrestamoFiltered}
                itemsSelected={prestamosFilters.LOAN_CREATOR}
                searchItem={searchCreadorPrestamo}
                setItemsSelected={(creator) => {
                  handlePrestamosFiltersInLocal({ LOAN_CREATOR: creator })
                }}
                onSearchItem={onSearchCreadorPrestamo}
                label='nombre'
              />
            </div>
          </div>
        </Dialog>
      </AnimatePresence>
    </div>
  )
}
